import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-webhooks',
  templateUrl: './email-webhooks.component.html',
  styleUrls: ['./email-webhooks.component.css']
})
export class EmailWebhooksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
